import { styled } from '@material-ui/core/styles';
import { Box } from '@material-ui/core';
import lImg from '../../assets/illustration-direct-adding-a-client.png';
import rImg from '../../assets/illustration-send-link-to-client.png';
import lTitleImg from '../../assets/icon-direct-adding-client.png';
import rTitleImg from '../../assets/icon-send-link-to-client.png';
import logo from '../../assets/mtlawllc-logo-header.png';

export const Root = styled(Box)({
    color: '#9B9B9B',
    width: '100%',
    '& .cardWapper': {
        width: '100%',
    },
    '& .cardTitle': {
        fontSize: '24px',
        fontWeight: 'bold',
        marginBottom: '100px',
    },
    '& .card': {
        width: '476px',
        height: '498px',
        backgroundColor: '#fff',
        borderRadius: '28px',
        margin: '0 70px',
        padding: '59px 59px 10px 59px',
        position: 'relative',
        cursor: 'pointer',
        '& .title': {
            width: '365px',
            height: '90px',
            backgroundColor: '#fff',
            borderRadius: '6px',
            fontSize: '18px',
            fontWeight: 'bold',
            boxShadow: '0px 2px 4px 0px rgba(0,0,0,0.2)',
            position: 'absolute',
            padding: '20px',
            top: '-50px',
            '& .titleImg': {
                width: '56px',
                height: '56px',
                backgroundColor: '#1A9AE7',
                borderRadius: '50%',
                '& .lTitleImg': {
                    width: '27px',
                    height: '28px',
                    background: `url(${lTitleImg}) no-repeat center top/cover`,
                },
                '& .rTitleImg': {
                    width: '27px',
                    height: '28px',
                    background: `url(${rTitleImg}) no-repeat center top/cover`,
                },
            },
        },
        '& .body': {
            '& .desc': {
                padding: '0 20px',
            },
            '& .lImg': {
                width: '250px',
                height: '250px',
                background: `url(${lImg}) no-repeat center top/cover`,
            },
            '& .rImg': {
                width: '250px',
                height: '250px',
                background: `url(${rImg}) no-repeat center top/cover`,
            },
            '& .logoImg': {
                width: '158px',
                height: '36px',
                position: 'absolute',
                right: '30px',
                bottom: '20px',
                background: `url(${logo}) no-repeat center top/cover`,
            },
        },
    },
    '& .card:hover': {
        backgroundColor: '#1A9AE7',
        '& .body': {
            color: '#fff',
        },
        '& .line': {
            backgroundColor: '#fff',
        }
    },
    '& .line': {
        width: '100%',
        height: '1px',
        margin: '45px 0 40px 0 ',
        backgroundColor: '#9B9B9B',
    }
});